<div class="filters-mobile" #mobileFilters>
  <div class="container-fluid header">
    <div class="row border-bottom py-2">
      <div class="col-2 d-flex justify-content-end align-items-center">
        <i class="icon-chevron-left p-1 font-xl"
           *ngIf="showBackBtn"
           (click)="closeWithoutSaving()"></i>
      </div>
      <div class="col-8 font-sm d-flex align-items-center justify-content-center">
        <strong [translate]="'orderProcess.cakesOverview.searchCakesPanel.filters'"></strong>
      </div>
      <div class="col-2 d-flex justify-content-end align-items-center ">
        <i class="icon-close p-1 font-xl"
           *ngIf="showCloseBtn"
           (click)="closeWithoutSaving()"></i>
      </div>
    </div>
  </div>
  <div class="px-3 filters">
    <div *ngIf="model.allergens.length > 0 && !hiddenFilters?.allergens">
      <div class="font-xl fw-bold mb-2"
           [translate]="'orderProcess.cakesOverview.searchCakesPanel.allergens'"></div>
      <div class="d-flex">
        <ui-checkbox
          [(model)]="allergen.checked"
          *ngFor="let allergen of model.allergens">
          {{allergen.label}}
        </ui-checkbox>
      </div>
    </div>

    <div *ngIf="model.canHasMotive && !hiddenFilters?.canHasMotive">
      <div class="mt-4 mb-2 font-xl fw-bold">
        <span [translate]="'orderProcess.cakesOverview.searchCakesPanel.printingOnCake'"></span>&nbsp;&nbsp;
        <i class="icon-account-box text-primary pt-1 d-inline-block"></i>
      </div>
      <div class="d-flex">
        <ui-checkbox
          [(model)]="model.hasMotive">
          <span [translate]="'orderProcess.cakesOverview.searchCakesPanel.yesPlease'"></span>
        </ui-checkbox>
      </div>
    </div>

    <div *ngIf="model?.productGroups?.length > 0 && !hiddenFilters?.productGroups">
      <div class="mt-4 mb-2 font-xl fw-bold"
           [translate]="'orderProcess.cakesOverview.searchCakesPanel.selectCakeGroup'"></div>
      <div class="d-flex">
        <ui-checkbox-btn
          *ngFor="let group of model.productGroups"
          [(model)]="group.checked"
          (modelChange)="productGroupChanged(group)">
          {{group.label}}
        </ui-checkbox-btn>
      </div>
    </div>
  </div>
  <div class="px-3 py-3 border-top text-center footer">
    <button class="btn btn-pink btn-long" (click)="showFilters = false; onClose.emit(model)"
            [translate]="'orderProcess.cakesOverview.searchCakesPanel.seeCakes'"></button>
  </div>
</div>
